export default __webpack_public_path__ + "static/media/chevron_top.92e46232.svg";